<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="ChapterEdit" :model="formData" class="full-width-input" style="width: 100%;" :rules="rules"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="章节类型" prop="CourseChapter.chapterType">
            <el-radio-group class="input-item" v-model="formData.CourseChapter.chapterType"
              @change="onChapterTypeValueChange"
            >
              <el-radio v-for="item in ChapterEdit.chapterType.impl.dropdownList" :key="item.id"
                :label="item.id"
              >
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否必修" prop="CourseChapter.obligatoryFlag">
            <el-radio-group class="input-item" v-model="formData.CourseChapter.obligatoryFlag"
              @change="onObligatoryFlagValueChange"
            >
              <el-radio v-for="item in ChapterEdit.obligatoryFlag.impl.dropdownList" :key="item.id"
                :label="item.id"
              >
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="章节名称" prop="CourseChapter.chapterName">
            <el-input class="input-item" v-model="formData.CourseChapter.chapterName"
              :clearable="true" placeholder="请输入章节名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="章节时长" prop="CourseChapter.chapterTotalTime">
            <el-input class="input-item" v-model="formData.CourseChapter.chapterTotalTime"
              :clearable="true" placeholder="请填写学习视频时长(分钟)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学习积分" prop="CourseChapter.chapterScore">
            <el-select class="input-item" v-model="formData.CourseChapter.chapterScore" :clearable="true" filterable
              placeholder="请填写学习积分" :loading="ChapterEdit.chapterScore.impl.loading"
              @visible-change="ChapterEdit.chapterScore.impl.onVisibleChange"
              @change="onChapterScoreValueChange">
              <el-option v-for="item in ChapterEdit.chapterScore.impl.dropdownList" :key="item.id"
                :value="item.id" :label="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="显示顺序" prop="CourseChapter.showOrder">
            <el-input class="input-item" v-model="formData.CourseChapter.showOrder"
              :clearable="true" placeholder="显示顺序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="视频文件" prop="CourseChapter.chapterFile">
            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple
              :action="getUploadActionUrl('/admin/app/courseChapter/upload')"
              :data="{fieldName: 'chapterFile', asImage: false}"
              :on-success="onChapterFileUploadSuccess"
              :on-remove="onChapterFileRemoveFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              :limit="ChapterEdit.chapterFile.impl.maxCount"
              :file-list="ChapterEdit.chapterFile.impl.fileList"
              :show-file-list="true">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="其他附件" prop="CourseChapter.chapterExtFile">
            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple
              :action="getUploadActionUrl('/admin/app/courseChapter/upload')"
              :data="{fieldName: 'chapterExtFile', asImage: false}"
              :on-success="onChapterExtFileUploadSuccess"
              :on-remove="onChapterExtFileRemoveFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              :limit="ChapterEdit.chapterExtFile.impl.maxCount"
              :file-list="ChapterEdit.chapterExtFile.impl.fileList"
              :show-file-list="true">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="章节封面" prop="CourseChapter.chapterImages">
            <el-upload
              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"
              :action="getUploadActionUrl('/admin/app/courseChapter/upload')"
              :data="{fieldName: 'chapterImages', asImage: true}"
              :on-success="onChapterImagesUploadSuccess"
              :on-remove="onChapterImagesRemoveFile"
              :before-upload="pictureFile"
              :on-error="onUploadError"

              :show-file-list="false">
              <div v-if="ChapterEdit.chapterImages.impl.fileList && ChapterEdit.chapterImages.impl.fileList[0] != null" style="position: relative">
                <img class="upload-image-show"
                  :src="ChapterEdit.chapterImages.impl.fileList[0].url" />
                <div class="upload-img-del el-icon-close"
                  @click.stop="onChapterImagesRemoveFile(null, null)" />
              </div>
              <i v-else class="el-icon-plus upload-image-item"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('ChapterEdit:ChapterEdit:add')"
              @click="onAddClick()">
              保存
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              关闭
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { CourseChapterController, DictionaryController } from '@/api';

export default {
  name: 'ChapterEdit',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    },
    courseId: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        CourseChapter: {
          id: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          courseId: undefined,
          chapterName: undefined,
          chapterImages: undefined,
          chapterType: undefined,
          obligatoryFlag: undefined,
          chapterTotalTime: undefined,
          chapterScore: undefined,
          showOrder: undefined,
          chapterFile: undefined,
          chapterExtFile: undefined,
          upFlag: undefined,
          auditStatus: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'CourseChapter.chapterType': [
          {required: true, message: '请选择章节类型', trigger: 'change'}
        ],
        'CourseChapter.obligatoryFlag': [
          {required: true, message: '请选择是否必修', trigger: 'change'}
        ],
        'CourseChapter.chapterName': [
          {required: true, message: '请输入章节名称', trigger: 'change'}
        ],
        'CourseChapter.chapterTotalTime': [
          {required: true, message: '请输入章节时长', trigger: 'change'}
        ],
        'CourseChapter.chapterScore': [
          {required: true, message: '请选择学习积分', trigger: 'change'}
        ]
      },
      ChapterEdit: {
        formFilter: {
        },
        formFilterCopy: {
        },
        chapterType: {
          impl: new DropdownWidget(this.loadChapterTypeDropdownList)
        },
        obligatoryFlag: {
          impl: new DropdownWidget(this.loadObligatoryFlagDropdownList)
        },
        chapterScore: {
          impl: new DropdownWidget(this.loadChapterScoreDropdownList)
        },
        chapterFile: {
          impl: new UploadWidget(1)
        },
        chapterExtFile: {
          impl: new UploadWidget(5)
        },
        chapterImages: {
          impl: new UploadWidget(1)
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 章节类型下拉数据获取函数
     */
    loadChapterTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictCourseTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 章节类型选中值改变
     */
    onChapterTypeValueChange (value) {
    },
    /**
     * 是否必修下拉数据获取函数
     */
    loadObligatoryFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否必修选中值改变
     */
    onObligatoryFlagValueChange (value) {
    },
    /**
     * 学习积分下拉数据获取函数
     */
    loadChapterScoreDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictScoreDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 学习积分选中值改变
     */
    onChapterScoreValueChange (value) {
    },
    /**
     * 更新章节信息编辑
     */
    refreshChapterEdit (reloadData = false) {
      this.loadCourseChapterData().then(res => {
        if (!this.ChapterEdit.isInit) {
          // 初始化下拉数据
          this.ChapterEdit.chapterType.impl.onVisibleChange(true).catch(e => {});
          this.ChapterEdit.obligatoryFlag.impl.onVisibleChange(true).catch(e => {});
        }
        this.ChapterEdit.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onAddClick () {
      this.$refs.ChapterEdit.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            chapterTypeDictMap: findItemFromList(this.ChapterEdit.chapterType.impl.dropdownList, this.formData.CourseChapter.chapterType, 'id'),
            obligatoryFlagDictMap: findItemFromList(this.ChapterEdit.obligatoryFlag.impl.dropdownList, this.formData.CourseChapter.obligatoryFlag, 'id'),
            chapterScoreDictMap: findItemFromList(this.ChapterEdit.chapterScore.impl.dropdownList, this.formData.CourseChapter.chapterScore, 'id'),
            ...this.formData.CourseChapter
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          courseChapterDto: {
            auditStatus: this.formData.CourseChapter.auditStatus,
            upFlag: this.formData.CourseChapter.upFlag,
            orgCode: this.formData.CourseChapter.orgCode,
            courseId: this.formData.CourseChapter.courseId,
            chapterName: this.formData.CourseChapter.chapterName,
            chapterImages: this.formData.CourseChapter.chapterImages,
            chapterType: this.formData.CourseChapter.chapterType,
            obligatoryFlag: this.formData.CourseChapter.obligatoryFlag,
            chapterTotalTime: this.formData.CourseChapter.chapterTotalTime,
            chapterScore: this.formData.CourseChapter.chapterScore,
            showOrder: this.formData.CourseChapter.showOrder,
            chapterFile: this.formData.CourseChapter.chapterFile,
            chapterExtFile: this.formData.CourseChapter.chapterExtFile
          }
        };

        CourseChapterController.add(this, params).then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    /**
     * 获取课程章节表详细信息
     */
    loadCourseChapterData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.CourseChapter.isDatasourceInit && this.supportCascadeAdd === '0') {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          CourseChapterController.view(this, params).then(res => {
            this.formData.CourseChapter = {...res.data, isDatasourceInit: true};
            this.ChapterEdit.chapterType.impl.onVisibleChange(true).catch(e => {});
            this.ChapterEdit.obligatoryFlag.impl.onVisibleChange(true).catch(e => {});
            if (this.formData.CourseChapter.chapterScoreDictMap && this.ChapterEdit.chapterScore.impl.dirty) {
              this.ChapterEdit.chapterScore.impl.dropdownList = [this.formData.CourseChapter.chapterScoreDictMap];
            }
            let chapterFileDownloadParams = {
              id: this.formData.CourseChapter.id,
              fieldName: 'chapterFile',
              asImage: false
            }
            this.ChapterEdit.chapterFile.impl.fileList = this.parseUploadData(this.formData.CourseChapter.chapterFile, chapterFileDownloadParams);
            let chapterExtFileDownloadParams = {
              id: this.formData.CourseChapter.id,
              fieldName: 'chapterExtFile',
              asImage: false
            }
            this.ChapterEdit.chapterExtFile.impl.fileList = this.parseUploadData(this.formData.CourseChapter.chapterExtFile, chapterExtFileDownloadParams);
            let chapterImagesDownloadParams = {
              id: this.formData.CourseChapter.id,
              fieldName: 'chapterImages',
              asImage: true
            }
            this.ChapterEdit.chapterImages.impl.fileList = this.parseUploadData(this.formData.CourseChapter.chapterImages, chapterImagesDownloadParams);
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseChapter.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 视频文件上传成功
     */
    onChapterFileUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.ChapterEdit.chapterFile.impl.onFileChange(file, fileList);
        this.formData.CourseChapter.chapterFile = this.fileListToJson(this.ChapterEdit.chapterFile.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除视频文件
     */
    onChapterFileRemoveFile (file, fileList) {
      this.ChapterEdit.chapterFile.impl.onFileChange(file, fileList);
      this.formData.CourseChapter.chapterFile = this.fileListToJson(this.ChapterEdit.chapterFile.impl.fileList);
    },
    /**
     * 其他附件上传成功
     */
    onChapterExtFileUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.ChapterEdit.chapterExtFile.impl.onFileChange(file, fileList);
        this.formData.CourseChapter.chapterExtFile = this.fileListToJson(this.ChapterEdit.chapterExtFile.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除其他附件
     */
    onChapterExtFileRemoveFile (file, fileList) {
      this.ChapterEdit.chapterExtFile.impl.onFileChange(file, fileList);
      this.formData.CourseChapter.chapterExtFile = this.fileListToJson(this.ChapterEdit.chapterExtFile.impl.fileList);
    },
    /**
     * 章节封面上传成功
     */
    onChapterImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.ChapterEdit.chapterImages.impl.onFileChange(file, fileList);
        this.formData.CourseChapter.chapterImages = this.fileListToJson(this.ChapterEdit.chapterImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除章节封面
     */
    onChapterImagesRemoveFile (file, fileList) {
      this.ChapterEdit.chapterImages.impl.onFileChange(file, fileList);
      this.formData.CourseChapter.chapterImages = this.fileListToJson(this.ChapterEdit.chapterImages.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        CourseChapter: {
          id: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          courseId: undefined,
          chapterName: undefined,
          chapterImages: undefined,
          chapterType: undefined,
          obligatoryFlag: undefined,
          chapterTotalTime: undefined,
          chapterScore: undefined,
          showOrder: undefined,
          chapterFile: undefined,
          chapterExtFile: undefined,
          upFlag: undefined,
          auditStatus: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshChapterEdit();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.CourseChapter = {
        ...this.rowData
      }
      this.ChapterEdit.chapterType.impl.onVisibleChange(true).catch(e => {});
      this.ChapterEdit.obligatoryFlag.impl.onVisibleChange(true).catch(e => {});
      if (this.formData.CourseChapter.chapterScoreDictMap && this.ChapterEdit.chapterScore.impl.dirty) {
        this.ChapterEdit.chapterScore.impl.dropdownList = [this.formData.CourseChapter.chapterScoreDictMap];
      }
      let chapterFileDownloadParams = {
        id: this.formData.CourseChapter.id,
        fieldName: 'chapterFile',
        asImage: false
      }
      this.ChapterEdit.chapterFile.impl.fileList = this.parseUploadData(this.formData.CourseChapter.chapterFile, chapterFileDownloadParams);
      let chapterExtFileDownloadParams = {
        id: this.formData.CourseChapter.id,
        fieldName: 'chapterExtFile',
        asImage: false
      }
      this.ChapterEdit.chapterExtFile.impl.fileList = this.parseUploadData(this.formData.CourseChapter.chapterExtFile, chapterExtFileDownloadParams);
      let chapterImagesDownloadParams = {
        id: this.formData.CourseChapter.id,
        fieldName: 'chapterImages',
        asImage: true
      }
      this.ChapterEdit.chapterImages.impl.fileList = this.parseUploadData(this.formData.CourseChapter.chapterImages, chapterImagesDownloadParams);
    }
  },
  watch: {
  }
}
</script>
